import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a8596e0e")

_pushScopeId("data-v-a8596e0e")
const _hoisted_1 = { class: "account_manage_mask" }
const _hoisted_2 = { class: "account_manage_module" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "user_info" }
const _hoisted_5 = { class: "avatar" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "我的头像", -1)
const _hoisted_7 = { class: "nickname_openid" }
const _hoisted_8 = { class: "nickname" }
const _hoisted_9 = { class: "openid" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "line" }, null, -1)
const _hoisted_11 = { class: "manage_module" }
const _hoisted_12 = { class: "login_type" }
const _hoisted_13 = { class: "nickname" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountManageHeader = _resolveComponent("AccountManageHeader")!
  const _component_WechatVerification = _resolveComponent("WechatVerification")!
  const _component_PhoneVerification = _resolveComponent("PhoneVerification")!
  const _component_WechatLogin = _resolveComponent("WechatLogin")!
  const _component_VerificationFail = _resolveComponent("VerificationFail")!
  const _component_AccountDeleteNotice = _resolveComponent("AccountDeleteNotice")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_AccountManageHeader, { onClose: _ctx.closeWindow }, null, 8, ["onClose"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: _ctx.viewModel.avatar
            }, null, 8, ["src"]),
            _hoisted_6
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("p", _hoisted_8, "我的昵称：" + _toDisplayString(_ctx.viewModel.nickname), 1),
            _createVNode("div", _hoisted_9, [
              _createVNode("p", null, "账号ID：" + _toDisplayString(_ctx.viewModel.openId), 1),
              _createVNode("div", {
                class: "copy",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyOpenId && _ctx.copyOpenId(...args)))
              }, "复制"),
              _createVNode("div", {
                class: "deregister",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickDeRegister && _ctx.clickDeRegister(...args)))
              }, "注销")
            ])
          ])
        ]),
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("img", {
              src: _ctx.loginTypeObj.icon
            }, null, 8, ["src"]),
            _createVNode("p", null, _toDisplayString(_ctx.loginTypeObj.name), 1)
          ]),
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.loginDisplayName), 1)
        ])
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.viewModel.isShowWechatVerification)
            ? (_openBlock(), _createBlock(_component_WechatVerification, {
                key: 0,
                "login-type": _ctx.viewModel.loginType,
                nickname: _ctx.viewModel.nickname,
                onClose: _cache[3] || (_cache[3] = () => _ctx.closeModal('wechat')),
                onConfirm: _ctx.openWechatLogin
              }, null, 8, ["login-type", "nickname", "onConfirm"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.viewModel.isShowPhoneVerification)
            ? (_openBlock(), _createBlock(_component_PhoneVerification, {
                key: 0,
                onClose: _cache[4] || (_cache[4] = () => _ctx.closeModal('phone')),
                onConfirm: _ctx.onPhoneVerificationConfirm
              }, null, 8, ["onConfirm"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.viewModel.isShowWechatLogin)
            ? (_openBlock(), _createBlock(_component_WechatLogin, {
                key: 0,
                onClose: _cache[5] || (_cache[5] = () => _ctx.closeModal('wechatLogin')),
                onSuccess: _ctx.onWechatVerificationSuccess,
                onError: _ctx.onWechatVerificationError
              }, null, 8, ["onSuccess", "onError"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.viewModel.isShowVerificationFail)
            ? (_openBlock(), _createBlock(_component_VerificationFail, {
                key: 0,
                onClose: _cache[6] || (_cache[6] = () => _ctx.closeModal('verificationFail'))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withId(() => [
          (_ctx.viewModel.isShowAccountDeleteNotice)
            ? (_openBlock(), _createBlock(_component_AccountDeleteNotice, {
                key: 0,
                "close-token": _ctx.viewModel.closeToken,
                onClose: _cache[7] || (_cache[7] = () => _ctx.closeModal('deleteNotice')),
                onSuccess: _ctx.onDeleteAccountSuccess
              }, null, 8, ["close-token", "onSuccess"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
})